module.exports = __webpack_public_path__ + "static/media/aalokkumar.2b736391.png";